<template>
  <NotificationMessage :title="$t('newRelease.title')" :size="PopUpSize.Large" @close="hideModal">
    <ReleaseCarousel :new-release="newRelease" @complete-new-release="hideModal"></ReleaseCarousel>
  </NotificationMessage>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ReleaseCarousel from './release-carousel.vue';
import { FeatureReleaseModel } from '@onrunning/backstage-models';
import NotificationMessage from '@/components/common/NotificationMessage.vue';
import { PopUpSize } from '@/models/pop-up-size.enum';

interface Props {
  featureRelease: FeatureReleaseModel | undefined;
}

const props = defineProps<Props>();
const emits = defineEmits(['hideModal']);

const newRelease = ref(props.featureRelease);

const hideModal = () => {
  emits('hideModal');
};
</script>
